import { getShortFormat, getLocaleFormat } from 'utils/numbers';

export default function Digit(params) {
    const { value, locale, shortFormat = false, localeStringOptions, otherOptions, data } = params;

    const numberCell = document.createElement('div');
    numberCell.classList.add('w5-number-cell');

    if ((value === null || value === undefined) && otherOptions?.emptyIfNull) {
        return numberCell;
    }

    let number = value;

    if (typeof number === 'string') {
        number = number.replace(',', '.');
    }
    number = Number(number);
    if (isNaN(number)) {
        return numberCell;
    }

    // Support localeStringOptions as a function that receives params.data for dynamic decimal calculation
    let options = localeStringOptions;
    if (typeof options === 'function') {
        options = options(data, params);
    }

    if (shortFormat) number = getShortFormat(number, locale);
    else number = getLocaleFormat(number, locale, options);

    numberCell.innerText = number;
    return numberCell;
}
